import React from 'react';
import BaseScoreForm from './BaseScoreForm';
import { ScoreDTO } from '../../services/apiClient';
import { ScoreTypeConstants } from '../../constants/ScoreTypeConstants';

interface ScoreFormProps {
  initialValues: ScoreDTO;
  onSubmit: (data: ScoreDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const ScoreForm: React.FC<ScoreFormProps> = (props) => {
  return (
    <BaseScoreForm
      {...props}
      scoreTypeConstant={ScoreTypeConstants.IN_HOUSE}
      eventTypeMessage={`Event Type: ${props.initialValues.scoreType?.title || 'In-House'} Postal Shoot`}
    />
  );
};

export default ScoreForm;
